export default "__VITE_ASSET__DSUPTb8w__"